import { loginFormErrors, resetFormErrors } from './../../shared/constants/form-error.constants';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { User } from '../../shared/models/user';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, CookieService, SessionStorageService, PageActionService, ButtonConfig, ModalService } from '@collab/comp-library';
import { AuthenticationService } from './service/authentication.service';
import { LandingPageService } from '../landing-page/service/landing-page.service';
import { ContactUsService } from 'src/app/shared/component/contact-us/service/contact-us.service';
import { ModalConfig } from '@collab/comp-library/ui/modal/modal.config';


@Component({
    selector: 'app-login',
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit,OnDestroy {
  @Output() passwordResetCompleted: EventEmitter<void> = new EventEmitter<void>();
    public loginForm: UntypedFormGroup = this.createForm();
    public resetEmail: UntypedFormGroup = this.resetPasswordEmail();
    public isFormSubmitted = false;
    public isEmailFormSubmitted =false;
    public errors: string[] = [];
    public emailerrors: string[] = [];
    public loginFormErrors = loginFormErrors;
    public resetFormErrors=resetFormErrors;
    public isTextFieldType = true;
    public visible = "assets/icons/visible.svg";
    public invisible = "assets/icons/invisible.svg";
    public user: User | undefined;
    public isEmpty: boolean = false;
    public isSuccess = false;
    public sucessMessage: string = '';
    public rememberMe: boolean = false;
    public showModal: boolean = false;
    public modalConfig: ModalConfig | undefined;
    public resetPassword=false;
    public confirmEmail=false;
    public newPassword=false;
    public loginButtonConfig: ButtonConfig = {
        text: 'Login',
        buttonType: 'primary',
        iconURL: '',
        imageUrl: '',
        linkURL: ''
    };
    public ResetPasswordButtonConfig: ButtonConfig = {
      text: 'Reset Password',
      buttonType: 'primary',
      iconURL: '',
      imageUrl: '',
      linkURL: ''
  };
  public BackToLoginButtonConfig: ButtonConfig = {
    text: 'Back to Login',
    buttonType: 'primary',
    iconURL: '',
    imageUrl: '',
    linkURL: ''
};
    public contactUsButtonConfig: ButtonConfig = {
        text: "Contact Us",
        buttonType: "secondary",
        buttonSize: "small",
        iconURL: "",
        imageUrl: "",
        linkURL: "",
    };
    private element:undefined |HTMLElement;
 
    constructor(private cookieService: CookieService, private formBuilder: UntypedFormBuilder, private router: Router,
        private authenticationService: AuthenticationService, private activatedRoute: ActivatedRoute,
        private sessionStorageService: SessionStorageService, 
        private pageActionService: PageActionService,
        private landingPageService: LandingPageService,
        private contactUsService: ContactUsService,
        private modalService: ModalService
       ) {}

    public ngOnInit() {
      this.authenticationService.getNewPasswordState().subscribe((newPasswordState) => {
        this.newPassword = newPasswordState;
      });
        this.activatedRoute.queryParams
            .subscribe((params) => {
                if (params['error']) {
                    this.errors.push('Your session has expired. Please log in again.');
                    this.isEmpty = true;
                }

                if (params['passwordResetFlag']) {
                    this.sucessMessage = 'Your password has been updated. Use new password to login';
                    this.isSuccess = true;
                }
            }
        );

        this.modalConfig={
          id: 'terms-conditions',
          type: 'alert',
          title: "Terms of Service",
          closeButton: true,
          primaryButtonConfig: {
            text: "Ok",
            buttonType: "primary",
            buttonSize: "medium",
            imageUrl: "",
            linkURL: "",
            },
        }
  }

    /**
     *
     * this method will create a login form
     * @return {*}  {FormGroup}
     * @memberof LoginComponent
     */
    public createForm(): UntypedFormGroup {
        return this.formBuilder.group({
            username: [ '', [ Validators.required] ],
            password: [ '', [Validators.required] ],
        });
    }

    public resetPasswordEmail(): UntypedFormGroup {
      return this.formBuilder.group({
        email: [ '', [ Validators.required,Validators.pattern(/^[a-zA-Z0-9._-]{6,50}@([a-zA-Z0-9.-]+\.)+[a-zA-Z]{2,4}$/
        )] ],
      });
    }
    

    public forgetForm(){
      this.resetPassword=true
    }

    /**
     *
     * this method will toggle the password visibility
     * @returns {void}
     * @memberof LoginComponent
     */
    public togglePasswordFieldType(): void {
        this.isTextFieldType = !this.isTextFieldType;
    }

    /**
     *
     * this method will get the login form control values
     * @readonly
     * @memberof LoginComponent
     */
    get formControl() {
        return this.loginForm.controls;
    }

    /**
     *  this method will do authentication
     * @returns {void}
     * @memberof LoginComponent
     */
    public login(): void {
        this.isFormSubmitted = true;
        this.errors = [];

        if (this.isFormvalid()) {
            this.authenticationService.getAppToken().subscribe((tokenResponse) => {
                if (tokenResponse) {
                  this.authenticationService
                    .logIn(
                      this.formControl['username'].value,
                      this.formControl['password'].value,
                      tokenResponse
                    )
                    .subscribe(
                      (data: any) => {
                        this.onAuthentication(data);
                      },
                      (error: any) => {
                        this.errors.push(error);
                      }
                    );
                  this.isEmpty = true;
                }
            })
        }
    }

    /**
     *
     * this method is validates the form
     * @return {*}  {boolean}
     * @memberof LoginComponent
     */
    public isFormvalid(): boolean {
        return this.loginForm.valid;
    }

    public convertToFormControl(absCtrl: AbstractControl | null): FormControl {
      const ctrl = absCtrl as FormControl;
      return ctrl;
  }
  public openLandingPage(data:any){
    if (!data.body.password_reset_required) {
      this.authenticationService
        .getUserRoles()
        .subscribe((response: any) => {
          if (response && response.userRoleResponse && response.userRoleResponse.avaUserId) {
            this.pageActionService.pageActions = response.userRoleResponse.pageActions;
            this.landingPageService.setProductsList(response.productCardList);
            this.sessionStorageService.setStorage(
              "userId",
              response.userRoleResponse.avaUserId
            );
          }
          this.router.navigate([
            "/landing-page/all-products"
          ]);
        });
    } else {
      this.newPassword=true;
    }
  }

  public onAccess(data:any){
    if (
      data["headers"].get(ACCESS_TOKEN_KEY) &&
      data["headers"].get(REFRESH_TOKEN_KEY)
      ) { 
      this.cookieService.setCookie(
        ACCESS_TOKEN_KEY,
        data["headers"].get(ACCESS_TOKEN_KEY),
        30
      );
      this.cookieService.setCookie(
        REFRESH_TOKEN_KEY,
        data["headers"].get(REFRESH_TOKEN_KEY),
        30
      );
      this.authenticationService.accessToken =
        data["headers"].get(ACCESS_TOKEN_KEY);
        this.openLandingPage(data)
    }
  }
  public onAuthentication(data:any){
    if (data && data.body && data.body.authenticated) {
      this.user = data;
      this.authenticationService.setUserDetails(data);
      this.onAccess(data);
    } else {
      this.errors.push(data.body.message);
    }
  }

  public contactUs() {
    this.contactUsService.isContactUsShow = true;
  }

  public openModal() {
  if (this.modalConfig && this.modalConfig.id) {
    this.modalService.open('terms-conditions');
  }
  }

  public closeModal(): void {
    if (!this.showModal) {
      this.showModal = true;
      setTimeout(() => {
        if (this.modalConfig && this.modalConfig.id) {
          this.modalService.close(this.modalConfig.id);
        }
        this.showModal = false;
      });
    }
  }

  public ngOnDestroy(): void {
    if (this.modalConfig && this.modalConfig.id) {
    this.modalService.remove(this.modalConfig?.id);
    }
    this.element?.remove();
    document.body.classList.remove('modal-open');
  }

  public onResetPassword() {
    const email = this.resetEmail.controls['email'].value;
    this.isEmailFormSubmitted=true
    this.authenticationService.getAppToken().subscribe((tokenResponse) => {
      if (tokenResponse) {
    this.authenticationService.passwordResetEmail(email,tokenResponse).subscribe(
      (response: any) => {
        this.confirmEmail = true;
      },
      (errors: any) => {
        this.emailerrors.push(errors);
        this.isEmpty = true;
      }
    );
    }
    })
    this.isEmpty = false;
  }
  public resetNewPasswordFlag(): void {
    this.newPassword = false;
  }

  public backToLogin(){
    this.resetPassword=false;
    this.confirmEmail=false;
    this.resetNewPasswordFlag();
  }
}
